import { publicEnvConfig } from 'helpers/env';
import { notifyError } from 'helpers/errorNotifier';

export const getOktaDomain = () => {
	try {
		const domain = new URL(publicEnvConfig.OKTA_ISSUER).origin;
		return domain;
	} catch (e) {
		notifyError('Error generating Okta settings URL', e);
		return '/';
	}
};

export const getOktaUserSettingsUrl = () => {
	try {
		const domain = getOktaDomain();
		return `${domain}/enduser/settings`;
	} catch (e) {
		notifyError('Error generating Okta settings URL', e);
		return '/';
	}
};
